import React from "react";
import FooterCategoryData from "./FooterCategoryData";

const DesktopFooterCategoryContainer = () => {
  return (
    <>
      {FooterCategoryData.map((category) => (
        <div
          className="hidden md:flex md:flex-col"
          key={category.categoryHeader}
        >
          <h3
            className="text-white text-lg font-bold antialiased m-0 leading-normal"
            style={{ textShadow: "none" }}
          >
            {category.categoryHeader}
          </h3>
          <ul className="m-0 list-none md:pt-2">
            {category.categoryList.map((list) => (
              <li key={list.name}>
                <a
                  className="text-sm text-white hover:underline antialiased leading-normal"
                  style={{ textShadow: "none" }}
                  {...(list.name.toLowerCase() === "safety recall" && {
                    target: "_blank",
                    rel: "noopener",
                  })}
                  href={list.link}
                >
                  {list.name}
                </a>
              </li>
            ))}
          </ul>
        </div>
      ))}
    </>
  );
};

export default DesktopFooterCategoryContainer;
